'use client'

import {useEffect, useEffectEvent} from 'react'

/**
 * Leaves for the payment provider at once, as every other online payment does; the action that
 * started it stays busy until the page is gone. Back from the provider the browser may restore this
 * page from its back/forward cache: `onReturn` then unlocks the action.
 */
export function usePaymentRedirect(onReturn: () => void): (paymentUrl: string) => void {
    const handleReturn = useEffectEvent(onReturn)
    useEffect(() => {
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) handleReturn()
        }
        window.addEventListener('pageshow', handlePageShow)
        return () => window.removeEventListener('pageshow', handlePageShow)
    }, [])
    return (paymentUrl: string) => window.location.assign(paymentUrl)
}
